var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "col-sm-12 btn btn-success",
      attrs: { type: "button" },
      on: {
        click: function($event) {
          return _vm.showHistory()
        }
      }
    },
    [
      _vm._v(
        "\n  " +
          _vm._s(_vm.trans("client.common.moneybox_modal_title_button")) +
          "\n"
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ebe3fa0c", { render: render, staticRenderFns: staticRenderFns })
  }
}